// extracted by mini-css-extract-plugin
export default {"BaseCell":"number-renderer-module__BaseCell__Kog0F2V"};